import React from "react";
import { groupDailyCandidates, formatDay } from "../api/shape.js";
import { PhoneFullScreen, Svg, ICON } from "./PhoneShell.jsx";


/**
 * The phone daily-list upload (UploadDaily.dc.html): the file just chosen, the
 * rows read from it, and one button. No person is chosen here (D1): the rows
 * arrive on Today unassigned. Runs on the existing import state (preview ->
 * commit), so the same routes and row selection apply.
 */
export default function PhoneUploadDaily({ panel, onChange, onCommit, onDismiss }) {
  const phase = panel.phase;
  const rows = panel.candidates || [];
  const grouped = groupDailyCandidates(rows);
  const skipped = (panel.counts || []).find((c) => c.label === "skipped");
  const selected = panel.selectedKeys || new Set();
  const code = panel.code || "";

  if (phase === "uploading" || phase === "committing" || phase === "committed" || phase === "error") {
    return (
      <PhoneFullScreen title="Today's yard list" titleId="ph-dy-upload-title" cancelStyle backLabel={phase === "committed" ? "Close" : "Cancel"} onBack={onDismiss} testId="ph-today-upload">
        {phase === "uploading" ? (
          <div role="status" className="ph-card statusbox"><span style={{ fontSize: 16, fontWeight: 600 }}>Uploading and reading…</span><div className="ph-bar run"><span /></div></div>
        ) : null}
        {phase === "committing" ? (
          <div role="status" className="ph-card statusbox"><span style={{ fontSize: 16, fontWeight: 600 }}>Adding to Today…</span><div className="ph-bar run"><span /></div><span className="ph-dy-muted">Keep this screen open until it finishes.</span></div>
        ) : null}
        {phase === "committed" ? (
          <div role="status" className="ph-card okbox">
            <span style={{ color: "var(--ph-ok)" }}><Svg size={24} stroke={2.2}>{ICON.checkCircle}</Svg></span>
            <span className="ph-stack"><span style={{ fontSize: 16, fontWeight: 600, color: "var(--ph-ok-ink)" }}>Added to Today. Choose who attends each inspection.</span></span>
          </div>
        ) : null}
        {phase === "committed" ? <button type="button" className="ph-btn pri" onClick={onDismiss}>Back to Today</button> : null}
        {phase === "error" ? (
          <div role="alert" className="ph-card badbox" data-testid="plan-import-error"><span style={{ color: "var(--ph-bad-ink)" }}>{panel.message}</span></div>
        ) : null}
      </PhoneFullScreen>
    );
  }

  return (
    <PhoneFullScreen
      title="Today's yard list"
      subtitle={code}
      titleId="ph-dy-upload-title"
      cancelStyle
      backLabel="Cancel"
      onBack={onDismiss}
      testId="ph-today-upload"
      footer={
        <button type="button" className="ph-btn pri" data-testid="ph-today-upload-apply" disabled={selected.size === 0} onClick={onCommit}>Add to Today</button>
      }
    >
      <div className="ph-dy-filecard" data-testid="ph-import-file">
        <span style={{ color: "var(--ph-ok-text)" }}><Svg size={28}>{<><path d="M6 3h9l4 4v14H6z" /><path d="M9 13l2 2 4-4" /></>}</Svg></span>
        <span className="ph-stack grow">
          <span className="ph-mono" style={{ fontSize: 12, color: "var(--ph-t1)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{panel.fileName || "Yard list"}</span>
          <span className="ph-dy-muted">
            {grouped.date ? `Read for ${formatDay(grouped.date)} · ` : "Read · "}
            {grouped.lines.length} {grouped.lines.length === 1 ? "line" : "lines"}, {grouped.sides} {grouped.sides === 1 ? "side" : "sides"} for {code}
          </span>
        </span>
        <button type="button" className="ph-textbtn" data-testid="ph-import-change" onClick={onChange}>Change</button>
      </div>
      <div className="ph-dy-rows" data-testid="plan-import-candidates">
        {grouped.lines.map((line) => (
          <div className="ph-dy-row" key={line.key} data-testid="plan-import-candidate">
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span className="ph-dy-time" style={{ fontSize: 12 }}>{line.time || "—"}</span>
              <span style={{ flex: 1 }} />
              <span className="ph-dy-chip">{line.sideLabel}</span>
            </div>
            <span className="ph-dy-item">{line.title}</span>
            {line.place ? <span className="ph-dy-muted">{line.place}</span> : null}
          </div>
        ))}
      </div>
      <p className="ph-dy-note">The inspections arrive on Today without a name. You choose who attends each one there.</p>
      {skipped && skipped.count ? <p className="ph-dy-muted">{skipped.count} {skipped.count === 1 ? "row" : "rows"} for another ship {skipped.count === 1 ? "was" : "were"} left out.</p> : null}
    </PhoneFullScreen>
  );
}
